import axios from 'axios'
import { Loading as ElLoading } from 'element-ui'

const DEFAULT_LOADING = true

class http {
  constructor(config) {
    // 保存基本信息
    this.instance = axios.create(config)
    this.interceptors = config.interceptors
    this.isShowLoading = config.isShowLoading ?? DEFAULT_LOADING

    // 部分实例拥有的拦截器
    this.instance.interceptors.request.use(this.interceptors?.requestInterceptor, this.interceptors?.requestInterceptorCatch)
    this.instance.interceptors.response.use(this.interceptors?.responseInterceptor, this.interceptors?.responseInterceptorCatch)

    //  每个实例对象都有的拦截器
    this.instance.interceptors.request.use(
      config => {
        if (this.isShowLoading) {
          this.loading = ElLoading.service({
            lock: false,
            text: '正在加载中。。。',
            background: 'rgba(0, 0, 0, 0.5)',
            customClass: 'server-loading'
          })
        }

        // console.log('所有请求的拦截')
        return config
      },
      err => {
        // console.log('所有请求错误')
        return err
      }
    )
    this.instance.interceptors.response.use(
      res => {
        this.loading?.close()
        res = res.data
        // console.log('所有响应的拦截')
        return res
      },
      err => {
        this.loading?.close()
        // console.log('所有响应错误')
        return err
      }
    )
  }

  request(config) {
    return new Promise((resolve, reject) => {
      if (config.interceptors?.requestInterceptor) {
        config = config.interceptors.requestInterceptor(config)
      }

      // 更改loading
      if (config.isShowLoading === false) {
        this.isShowLoading = false
      }
      this.instance
        .request(config)
        .then(res => {
          if (config.interceptors?.responseInterceptor) {
            res = config.interceptors?.responseInterceptor(res)
          }
          this.isShowLoading = DEFAULT_LOADING
          // 将结果返回出去
          resolve(res)
        })
        .catch(err => {
          this.isShowLoading = DEFAULT_LOADING
          reject(err)
          return err
        })
    })
  }

  get(config) {
    return this.request({ ...config, method: 'GET' })
  }
  post(config) {
    return this.request({ ...config, method: 'POST' })
  }
  delete(config) {
    return this.request({ ...config, method: 'DELETE' })
  }
  patch(config) {
    return this.request({ ...config, method: 'PATCH' })
  }
}

export default http
